import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="48.12 27.41 48.12 47.81 27.11 47.9 17.34 34.29 33.97 12.11 48.12 27.41"
  />
);

export const AvatarArtworkBlacula = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.blacula}
    renderShadow={renderShadow}
  >
    <g
      style={{
        transform: 'scale(1.1) translate(-2px, -2px)',
        color: '#12110f',
      }}
    >
      <path
        d="M12.81,23.5c-.65-.14-1.14-.63-1.37-1.17s-.25-1.14-.24-1.72c.05-3.06.39-4.37,1.83-7.17.25.49,1.51-1.33,2.06-1.56.62-.26,1.19-.62,1.66-1.07.3-.28,2.48-3,6.91-3.01,4.11,0,7.24,2.14,8.02,3.01.24.27.49.55.83.72s1.79,1.62,2.11,1.43c2.02,2.51,2.15,4.16,2.19,7.22.02,1.13-.17,2.36-1.11,3.13-.43.35-1,.58-1.39.96-.49.48-.58.07-2.33.51.42-1.24.3-3.69-.16-4.92s-.65-3.13-1.92-3.48-5.47,4.61-5.89,4.46c-.68-.24-5.17-5.04-5.78-4.7-1,.56-1.56.54-1.7,1.56-.09.68.18,1.39-.09,2.03-.11.26-.3.49-.45.73-.25.41-.4.85-.48,1.3-.08.43.03.88-.03,1.31-.08.56.03.8.08,1.7-.08-.2-.46-.4-.59-.58-.2-.28-.41-.56-.81-.56-.46,0-.9-.06-1.34-.16Z"
        stroke="#12110f"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.56,33.72l-3.94,4.53c-.7.8-1.69,1.26-2.74,1.26h-1.79c-1.04,0-2.04-.46-2.74-1.27l-3.93-4.53c-.75-.87-1.16-2-1.15-3.17l.2-15.96c0-.43.27-.8.66-.94l7.56-2.54c.19-.06.4-.06.59,0l7.57,2.54c.39.13.66.51.66.94l.2,15.96c.01,1.17-.4,2.31-1.15,3.17Z"
        fill="#734c26"
      />
      <path d="M24.5,37.16c-.13.09-.73.05-.89-.03,0,0-1.52-.59-1.38-1.05.15-.49,3.35-.51,3.58,0,.2.44-1.31,1.08-1.31,1.08Z" />
      <g>
        <path
          d="M27.84,33.68c0,.39-1.72,1.47-3.84,1.47s-3.86-1.06-3.84-1.45c.01-.32,1.72-.33,3.85-.33s3.84-.01,3.84.31Z"
          fill="#4a2b0e"
        />
        <ellipse cx="24" cy="33.53" rx="3.44" ry=".64" />
        <polygon
          points="21.26 33.45 21.7 34.6 22.19 33.71 22.61 34.02 22.83 33.75 23.02 33.89 23.89 33.85 24.16 33.87 25.14 33.83 25.48 33.89 25.85 33.75 26.21 34.7 26.74 33.45 21.26 33.45"
          fill="#fefdfd"
        />
        <path
          d="M27.84,33.59c.1.28-.16-.16-1.64-.01-.66.06-1.54-.05-2.2-.05-.55,0-1.35.12-1.94.08-1.65-.13-2,.29-1.91-.01.11-.37,1.06-1.26,2.42-1.26.57,0,1.07.15,1.42.15.42,0,.45-.14,1.06-.15,1.51,0,2.64.86,2.78,1.26Z"
          fill="#36200b"
        />
      </g>
      <path d="M23.33,31.63s-.11.05-.17.07c-.6.11-1.2.19-1.8.25-.23.02-.47.04-.7.09-1.09.23-1.76,1.17-2.23,2.25-.21-1.13.21-2.38,1.12-3.07.79-.6,1.82-.76,2.81-.82.24-.02.48-.03.71.05.49.18.65.81.26,1.19Z" />
      <path
        d="M32,32.56c-.07.09-.17.18-.28.16-.06,0-.11-.04-.15-.08-.6-.47-1.04-1.11-1.46-1.75-.43-.65-.84-1.31-1.23-1.98.44-.18.94,0,1.41.13.59.15,1.21.19,1.82.12.48-.05.9-.28,1.09.26.32.91-.63,2.51-1.19,3.15Z"
        stroke="#211c19"
        strokeWidth="0.2"
        strokeLinejoin="round"
      />
      <path
        d="M16,32.56c.07.09.17.18.28.16.06,0,.11-.04.15-.08.6-.47,1.04-1.11,1.46-1.75.43-.65.84-1.31,1.23-1.98-.44-.18-.94,0-1.41.13-.59.15-1.21.19-1.82.12-.48-.05-.9-.28-1.09.26-.32.91.63,2.51,1.19,3.15Z"
        stroke="#211c19"
        strokeWidth="0.2"
        strokeLinejoin="round"
      />
      <path
        d="M32.41,25.64c-.03.58.03,1.11.1,1.56.11.7.08,1.57.76,1.61s.7-.81.92-1.48c.15-.44.25-.98.28-1.57.08-1.49.02-2.92-.55-2.96s-1.43,1.35-1.51,2.84Z"
        fill="#734c26"
      />
      <path d="M24.68,31.62s.11.06.17.07c.6.11,1.2.19,1.8.25.23.02.47.04.7.09,1.09.23,1.71,1.12,2.22,2.25.21-1.13-.2-2.38-1.11-3.08-.78-.61-1.82-.76-2.81-.83-.24-.02-.48-.03-.71.05-.49.17-.65.81-.26,1.19Z" />
      <path
        d="M15.58,25.64c.03.58-.03,1.11-.1,1.56-.11.7-.08,1.57-.76,1.61s-.7-.81-.92-1.48c-.15-.44-.25-.98-.28-1.57-.08-1.49-.02-2.92.55-2.96s1.43,1.35,1.51,2.84Z"
        fill="#734c26"
      />
      <path d="M15.37,24.46c-.41-.3-.71-.72-1.12-1.02-.27-.19-.57-.33-.85-.49s-.55-.38-.69-.68-.11-.69.13-.91c.09-.08.2-.14.32-.17.64-.19,1.34.23,1.69.8s.43,1.26.51,1.92" />
      <path d="M34.6,23.09c.09-.11.18-.24.17-.39,0-.11-.07-.21-.14-.3-.22-.32-.44-.64-.66-.97-.03-.05-.07-.1-.13-.1-.05,0-.09.03-.12.06-.2.18-.36.39-.49.62-.15.28-.25.6-.34.91-.14.47-.33.96-.43,1.44-.08.43.02.59.34.25.54-.58,1.29-.92,1.8-1.53Z" />
      <path
        d="M12.81,23.13c-.51-.42.63-6.48,1.19-7.82.23-.55,5.17-5.71,9.6-5.72,2.44,0,7.22.87,9.86,3.81,1.8,2.01,2.07,6.04,2.09,7.28.02,1.13-.12.93-.4,2.12-.1.44-.78.47-1.18.86-.49.48-.66.98-2.01,1.63.42-1.24.3-3.69-.16-4.92s-.65-3.13-1.92-3.48-5.47,4.61-5.89,4.46c-.68-.24-5.17-5.04-5.78-4.7-1,.56-1.56.54-1.7,1.56-.09.68.18,1.39-.09,2.03-.11.26-.3.49-.45.73-.25.41-.4.85-.48,1.3-.08.43.03.88-.03,1.31-.08.56.03.8.08,1.7-.08-.2-.46-.4-.59-.58-.2-.28-.41-1.05-.81-1.05-.46,0-.91-.17-1.35-.53Z"
        stroke="#211c19"
        strokeWidth="0.2"
        strokeLinejoin="round"
      />
      <path d="M13.4,22.26c-.06.3-.71,1.18-1,1.07-.29-.11-.36-.11-.43-.42-.28-1.28.01-2.6.3-3.88.47-2.12.96-4.28,2.02-6.17s2.81-3.53,4.94-3.92c.9-.17,1.83-.11,2.75-.12,1.51-.02,3.06-.22,4.52.19.62.17,1.21.46,1.84.58.64.13,1.31.09,1.95.23.94.21,1.76.78,2.42,1.49s1.16,1.53,1.67,2.35c.04.07.08.13.12.2.49.8.99,1.62,1.26,2.53.25.86.27,1.77.29,2.67.03,1.28.36,2.08.02,3.32-.07.26-.95.48-1.59-.45-.73-1.04-.86-1.92-1.44-3.05-.39-.75-.78-1.5-1.17-2.26-.15-.3-.31-.6-.55-.84-.23-.24-.53-.4-.82-.55-.97-.51-1.98-.97-3.03-1.27-.63-.18-1.28-.29-1.93-.41-.87-.15-1.74-.31-2.62-.34-1.8-.07-3.61.39-5.17,1.29-1.37.8-2.58,1.99-3.1,3.5-.49,1.41-.38,3.05-1.24,4.27" />
    </g>
  </AvatarArtwork>
);

export default AvatarArtworkBlacula;
